

export const nodata = '-'